import { Col, Container, Row } from 'reactstrap';
import './Prokects.css';
import React, { useEffect } from 'react';

import AOS from 'aos';
import 'aos/dist/aos.css';

import {
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  Button,
} from 'reactstrap';
import { Link } from 'react-router-dom';

const Projects = () => {
  const projects = [

    {
      name: 'Homes  Finder',
      photo: 'https://i.ibb.co/gJ1NW2Z/Screenshot-72.png',
      description:
        'A NextJs web app where people can order home related service',
      live: 'https://homes-finder-client.vercel.app/',
      github: 'https://github.com/Azim-Ahmed/homes-finder-client',
      id: 1,
    },
    {
      name: 'Creative Agency',
      photo: 'https://i.ibb.co/yfHjbGZ/1-Landing-page.png',
      description:
        'A website for those who want to handle their project smoothly',
      live: 'https://creative-agency-port.web.app',
      github: 'https://github.com/Azim-Ahmed/creative-agency-portal/',
      id: 2,
    },
    {
      name: 'Volunteer Network',
      photo: 'https://i.ibb.co/X5thRPH/voluteer.png',
      description:
        'A website for those enthusiast people who want to joinin volunteer services.',
      live: 'https://volunteer-network-portal.web.app/',
      github: 'https://github.com/Azim-Ahmed/volunteer-network',
      id: 3,
    },
    {
      name: 'Travel Guru',
      photo: 'https://i.ibb.co/zJ56xwM/travel-guru.png',
      description:
        'A travel web app where people can book their travel destination with authentication.',
      live: 'https://travel-guru-dhaka.web.app/',
      github: 'https://github.com/Azim-Ahmed/travel-guru-app',
      id: 4,
    },
  ];

  useEffect(() => {
    AOS.init({
      duration: 2200,
    });

    AOS.refreshHard();
  }, []);
  return (
    <Container className="projectsarea">
      <h1 className="text-center projects-header pb-4">FEATURED PROJECTS</h1>
      <h5>
        <Link to="/projects">See Details All Of Projects</Link>
      </h5>
      <Row className="mt-4 mb-5">
        {projects.map((item) => (
          <Col
            className="my-3"
            lg={4}
            sm={12}
            md={{
              size: 4,
              order: 1,
            }}
          >
            <Card
              data-aos="flip-left"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000"
              style={{
                border: '1px solid #b43838',
                borderRadius: '8px',
                boxShadow: '2px 4px 7px gray',
              }}
            >
              <CardImg
                top
                width="100%"
                style={{
                  height: '260px',
                }}
                src={item.photo}
                alt="Card image cap"
              />
              <CardBody>
                <CardTitle>
                  <h5>{item.name}</h5>
                </CardTitle>
                <CardText className="text-justify">{item.description}</CardText>
                <Button outline color="danger" className=" mr-3">
                  <a href={item.live}>Live Site</a>
                </Button>
                <Button outline color="success" className="ml-3">
                  <a href={item.github}>Repository</a>
                </Button>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Projects;
